import React from 'react';

const pairKey = (a, b) => [a, b].sort().join('|');

const describeInterest = (pair, nameA, nameB) => {
  const parts = [];
  if (pair.aInterested) parts.push(`${nameA} interested`);
  if (pair.bInterested) parts.push(`${nameB} interested`);
  if (pair.aNotInterested) parts.push(`${nameA} not interested`);
  if (pair.bNotInterested) parts.push(`${nameB} not interested`);
  return parts.join(', ');
};

// Plain-text history among currently "Suggest"-checked members, using the
// model's real status vocabulary (pending/accepted/rejected/one-sided) —
// not a friendlier translation layer. Pairs with no record are simply
// omitted; "not shown" already means "never suggested."
const RelationshipHistoryPanel = ({ suggestedMembers, historyByPairKey }) => {
  if (suggestedMembers.length < 2) return null;

  const rows = [];
  for (let i = 0; i < suggestedMembers.length; i++) {
    for (let j = i + 1; j < suggestedMembers.length; j++) {
      const m1 = suggestedMembers[i];
      const m2 = suggestedMembers[j];
      const pair = historyByPairKey.get(pairKey(m1.userId, m2.userId));
      if (!pair) continue;

      const aIsM1 = pair.a === m1.userId;
      const nameA = aIsM1 ? (m1.firstName || m1.userId) : (m2.firstName || m2.userId);
      const nameB = aIsM1 ? (m2.firstName || m2.userId) : (m1.firstName || m1.userId);
      const suggestedBits = [];
      if (pair.aSuggestedCount > 0) suggestedBits.push(`${nameA} suggested ${nameB} ×${pair.aSuggestedCount}`);
      if (pair.bSuggestedCount > 0) suggestedBits.push(`${nameB} suggested ${nameA} ×${pair.bSuggestedCount}`);
      const interestBit = describeInterest(pair, nameA, nameB);

      rows.push(
        <li key={pairKey(m1.userId, m2.userId)}>
          {nameA} ↔ {nameB} — <strong>{pair.status}</strong>
          {suggestedBits.length > 0 && <> · {suggestedBits.join(', ')}</>}
          {interestBit && <> · {interestBit}</>}
        </li>
      );
    }
  }

  if (rows.length === 0) {
    return <div className="as-suggestion-history-panel as-card-meta">No prior history among the selected members.</div>;
  }

  return (
    <div className="as-suggestion-history-panel">
      <span className="as-card-meta">Prior history:</span>
      <ul className="as-suggestion-history-list">{rows}</ul>
    </div>
  );
};

export default RelationshipHistoryPanel;
export { pairKey };
